<template>
	<div class="no-data-outer" :style="props.minHeight ? {minHeight: props.minHeight} : {}">
		<div class="no-data-body" :style="props.top ? {top: props.top} : {}">
			<img :src="notInfoSvg" :style="{width: props.size + 'px'}" alt="">
      <template v-if="$slots.text">
        <div>
          <slot name="text"></slot>
        </div>
      </template>
			<div v-else>{{props.text || $t( 'common.noData' )}}</div>
		</div>
	</div>
</template>
<script setup>
import { useLang } from "@shining3d/common-module/utils/lang.js";
import notInfoSvg from '../assets/image/notInfo.svg';

const { $t } = useLang( '@shining3d/app' );
const props = defineProps({
	size: {
		type: Number,
		default: 100
	},
	text: {
		type: String,
		default: ''
	},
	top: {
		type: String,
		default: ''
	},
	minHeight: {
		type: String,
		default: '200px'
	}
});
</script>
<style lang="scss" scoped>
.no-data-outer {
	width: 100%;
	height: 100%;
	min-height: 200px;
	position: relative;
	.no-data-body {
		position: absolute;
		top: 35%;
		left: 50%;
		text-align: center;
		transform: translate(-50%, -50%);
		div {
			margin-top: 5px;
			font-size: 14px;
			line-height: 1.5;
			color: $color-n6;
		}
	}
}
</style>
